import { useMutation } from '@apollo/client';
import { type Moment } from 'moment';
import {
  DECLINE_REFERRAL_MUTATION,
  ACCEPT_REFERRAL_MUTATION,
  SAVE_FIRST_AVAILABLE_APPOINTEMENT_DATE_MUTATION,
  TERMINATE_TODO_MUTATION,
} from '../queries';

interface UseConfirmAcceptanceMutationsProps {
  activityId: number;
  providerId: number;
  isMultiReferral: boolean;
  onAcceptCompleted?: () => void;
  onDeclineCompleted?: () => void;
}

export const useConfirmAcceptanceMutations = ({
  activityId,
  providerId,
  isMultiReferral,
  onAcceptCompleted,
  onDeclineCompleted,
}: UseConfirmAcceptanceMutationsProps) => {
  const [terminateToDo] = useMutation(TERMINATE_TODO_MUTATION, {
    context: { skipGlobalErrorHandling: true },
    onError: (err) => {
      console.error(err);
    },
  });

  const [declineCase, declineCaseMutation] = useMutation(DECLINE_REFERRAL_MUTATION, {
    onCompleted: onDeclineCompleted,
    errorPolicy: 'all',
  });

  const [acceptReferral, acceptReferralMutation] = useMutation(ACCEPT_REFERRAL_MUTATION, {
    variables: { activityId, providerId, isMultiReferral },
    onCompleted: onAcceptCompleted,
    errorPolicy: 'all',
  });

  const [saveDate, { loading: saveDateLoading }] = useMutation(
    SAVE_FIRST_AVAILABLE_APPOINTEMENT_DATE_MUTATION,
    {}
  );

  const saveDateMutation = (date: Moment) => {
    return saveDate({
      variables: {
        date: date.toISOString(true),
        activityId: activityId,
        providerId: providerId,
      },
    });
  };

  const declineCaseAfterDateOutsideParams = () => {
    return declineCase({
      variables: {
        activityId,
        isMultiReferral,
        providerId,
        reasonCode: 5,
      },
    });
  };

  const handleDecline = (reasonCode: number) => {
    return declineCase({
      variables: {
        activityId,
        isMultiReferral,
        providerId,
        reasonCode,
      },
    });
  };

  return {
    saveDateMutation,
    declineCaseAfterDateOutsideParams,
    handleDecline,
    acceptReferral,
    terminateToDo,
    saveDateLoading,
    declineCaseMutation,
    acceptReferralMutation,
  };
};
